export const CHAT_GROUP = '/chat_group/'
export const CHAT_GROUP_BY_COMPONENT = `${CHAT_GROUP}all` as const
export const CHAT_GROUP_DEACTIVATE = `${CHAT_GROUP}deactivate/` as const

export const MESSAGES_GROUP = '/messages/group/' as const
export const MESSAGES_GROUP_ALL = `${MESSAGES_GROUP}all` as const
